import { render, staticRenderFns } from "./DeploymentTesting.vue?vue&type=template&id=47daee57&"
import script from "./DeploymentTesting.vue?vue&type=script&lang=js&"
export * from "./DeploymentTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports